import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchPrioritizationIndicesSummary = (params = {}, limit = 20, page = 0) => {
  const itemsCount = `&limit=${limit}`;
  const offset = `&offset=${page * limit}`;

  return apiActionCreator({
    'endpoint': `/prioritization-indices/summary${getUrlParameters(params)}${itemsCount}${offset}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PRIORITIZATION_INDICES,
      ActionTypes.FETCHED_PRIORITIZATION_INDICES,
      [
        ActionTypes.FETCHED_PRIORITIZATION_INDICES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const downloadPrioritizationIndicesSummaryReport = (params = {}) => apiActionCreator({
  'endpoint': `/prioritization-indices/summary/excel${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_PRIORITIZATION_INDICES,
    ActionTypes.DOWNLOADED_PRIORITIZATION_INDICES,
    [
      ActionTypes.DOWNLOADED_PRIORITIZATION_INDICES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPrioritizationIndicesDetail = (params = {}, limit = 20, page = 0) => {
  const itemsCount = `&limit=${limit}`;
  const offset = `&offset=${page * limit}`;

  return apiActionCreator({
    'endpoint': `/prioritization-indices/detail${getUrlParameters(params)}${itemsCount}${offset}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PRIORITIZATION_INDICES,
      ActionTypes.FETCHED_PRIORITIZATION_INDICES,
      [
        ActionTypes.FETCHED_PRIORITIZATION_INDICES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const downloadPrioritizationIndicesDetailReport = (params = {}) => apiActionCreator({
  'endpoint': `/prioritization-indices/detail/excel${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_PRIORITIZATION_INDICES,
    ActionTypes.DOWNLOADED_PRIORITIZATION_INDICES,
    [
      ActionTypes.DOWNLOADED_PRIORITIZATION_INDICES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changePrioritizationIndicesListPage = (value) => ({
  'type': ActionTypes.CHANGE_PRIORITIZATION_INDICES_LIST_PAGE,
  'payload': value,
});

export const changePrioritizationIndicesListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_PRIORITIZATION_INDICES_LIST_PAGE_SIZE,
  'payload': value,
});

export const clearPrioritizationIndices = () => ({
  'type': ActionTypes.CLEAR_PRIORITIZATION_INDICES,
});
